import * as React from 'react';
import { Dialog, DialogType, DialogFooter, DialogContent } from '@fluentui/react/lib/Dialog';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { useBoolean } from '@fluentui/react-hooks';
import { TextField, MaskedTextField } from '@fluentui/react/lib/TextField';
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { ExceptionDialog } from './ExceptionDialog';

const modalPropsStyles = { main: { maxWidth: '50rem' } };
const dialogContentProps = {
  type: DialogType.normal,
  title: 'Purchase additional licenses',
  subText: 'Assign a license to one of your users',
};

const CreateLicenseDialog = (props) => {
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const { addLicenseToList, subscriptionId, setShowExceptionDialog, setExceptionMessage, setTokenExpired } = props;

  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: false,
    }),
    [],
  );


  const [userEmail, setUserEmail] = useState("");

  async function createLicenseAsync() {
    if(subscriptionId) {
      var licenseToCreate = {
          userGuid: generateGuid(),
          userEmail: userEmail,
          subscriptionId: subscriptionId
      }
      await postCreateLicense(licenseToCreate);
      toggleHideDialog();
    }
  }

  function onUserEmailChange(event) {
      setUserEmail(event.target.value);
  }

  
  function generateGuid() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

async function postCreateLicense(licenseToCreate) {
  if(licenseToCreate.userEmail !== "") {
    const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
        },
      };
      const bodyParameters = {
        userGuid: generateGuid(),
        userEmail: userEmail,
        subscriptionId: subscriptionId,
      };
    
      await axios
        .post(
          axios.defaults.baseURL + "/License/Create",
          bodyParameters,
          config
        )
        .then((result) => {
          setTokenExpired(false);
         addLicenseToList(result.data)
        })
        .catch(error => {
          setShowExceptionDialog(true)
          setExceptionMessage(error.response.data)
        });
  }
}

  return (
    <>
      <PrimaryButton style={{ fontSize:"1.5vh" }} disabled={subscriptionId == undefined} secondaryText="Assign License" onClick={toggleHideDialog} text="Assign License" />
      <Dialog
        hidden={hideDialog}
        onDismiss={toggleHideDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
          <DialogContent>
          <TextField required label="User email" defaultValue="" onChange={onUserEmailChange} />
          </DialogContent>
        <DialogFooter>
          <PrimaryButton onClick={createLicenseAsync} text="Create" />
          <DefaultButton onClick={toggleHideDialog} text="Cancel" />
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default CreateLicenseDialog;
